var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCentos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2488_147304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58199 9.34269L9.23326 9.99012L8.58199 10.6376H3.99833V12.7942L1.20361 9.99012L3.99833 7.23333V9.34269H8.58199Z",
    fill: "#932279"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6571 8.58205L10.0096 9.23332L9.3622 8.58205V3.99839H7.20557L10.0096 1.20367L12.7664 3.99839H10.6571V8.58205Z",
    fill: "#EFA724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4179 10.6573L10.7666 10.0099L11.4179 9.36248H16.0004V7.20585L18.7952 10.0099L16.0004 12.7667V10.6573H11.4179Z",
    fill: "#262577"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34276 11.418L9.99019 10.7667L10.6376 11.418V16.0016H12.7942L9.99019 18.7964L7.2334 16.0016H9.34276V11.418Z",
    fill: "#9CCD2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83545 3.83516H9.40399V9.4037H3.83545V3.83516Z",
    fill: "#9CCD2A",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5972 3.83516H16.1657V9.4037H10.5972V3.83516Z",
    fill: "#932279",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5972 10.5969H16.1657V16.1654H10.5972V10.5969Z",
    fill: "#EFA724",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83545 10.5969H9.40399V16.1654H3.83545V10.5969Z",
    fill: "#262577",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28125 10L5.21858 6.06269L9.15646 10L5.21858 13.9374L1.28125 10ZM6.06276 5.21851L10.0001 1.28117L13.9374 5.21851L10.0001 9.15639L6.06276 5.21851ZM10.8443 10L14.7816 6.06269L18.7189 10L14.7816 13.9374L10.8443 10ZM6.06276 14.7815L10.0001 10.8437L13.9374 14.781L10.0001 18.7189L6.06276 14.7815Z",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2488_147304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCentos);
export default __webpack_public_path__ + "static/media/ic-centos.8d368332e06540128256b50154a589dd.svg";
export { ForwardRef as ReactComponent };